import { handleActions } from 'redux-actions';
import { makeUniqueArray } from '@mw/helpers';

import {
  setTemplates,
  createTemplate,
  deleteTemplate,
} from '~/actions/media_storage';

export default handleActions(
  {
    [setTemplates]: (state, { payload }) => ({
      ...state,
      templates: makeUniqueArray([...payload, ...state.templates], 'id'),
    }),
    [createTemplate]: (state, { payload }) => ({
      ...state,
      templates: [...state.templates, payload],
    }),
    [deleteTemplate]: (state, { payload: template_id }) => ({
      ...state,
      templates: state.templates.filter(({ id }) => id !== template_id),
    }),
  },
  {
    templates: [],
  }
);
